import React, {memo, useCallback, useContext, useRef, useState} from 'react';
import Icon from '@bonprix/pattern-library/templates/icon';
import Loader from '@bonprix/pattern-library/templates/loader/default';import {Constants} from '../view-constants';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import useEffectOnUpdate from '../helper/hooks-helper';

export default function AlpiHeroPicture({
                                            url,
                                            image,
                                            inView,
                                            heroPictureOnClick,
                                            onLoad,
                                            heroPictureOnAuxClick,
                                            heroPictureOnContextMenu,
                                        }) {
    const {imagePath} = useContext(articleOverviewStaticContext);

    const [loaded, setLoaded] = useState(false);
    const [showFallback, setShowFallback] = useState(false);
    const linkTagRef = useRef();
    const timer = useRef();

    const onAuxClick = (e) => {
        heroPictureOnAuxClick(e, linkTagRef.current);
    };
    const onContextMenu = (e) => {
        heroPictureOnContextMenu(e, linkTagRef.current);
    };

    const handleImageLoad = () => {
        clearTimeout(timer.current);
        onLoad();
        setLoaded(true);
        setShowFallback(false);
    };

    useEffectOnUpdate(() => {
        if (inView && !loaded) {
            timer.current = setTimeout(() => {
                setShowFallback(true);
                onLoad();
            }, 15000);
        }
    }, [inView])

    return (
        <div className="alpi__image" data-testid="alpi__image" onClick={heroPictureOnClick} onContextMenu={onContextMenu} onAuxClick={onAuxClick}>
            {inView || loaded ? inViewImage() : <Loading/>}
        </div>
    );

    function inViewImage() {
        const fallbackNeeded = (image?.sources?.length === 0 && !image?.fallbackSrc) || showFallback;
        const showLoader = fallbackNeeded ? false : !loaded;

        const visibilityStyle = loaded || fallbackNeeded ? {} : {display: 'none'};

        return (
            <>
                {showLoader && <Loading/>}
                <a ref={linkTagRef} className="alpi__image-link" href={url}>
                    {fallbackNeeded && <FallbackImage altText={image.alt}/>}
                    <picture className={'alpi__picture-wrapper'} style={visibilityStyle}>
                        {image.sources.map((source, index) => {
                            return (
                                <source
                                    key={index}
                                    media={source.media}
                                    srcSet={imagePath + source.srcSet.src + ', ' + imagePath + source.srcSet.src2x}
                                />
                            );
                        })}
                        <img
                            className="responsive-image__img-tag"
                            onLoad={handleImageLoad}
                            src={image.fallbackSrc}
                            alt={image.alt}
                            height={Constants.DEFAULT_IMAGE_HEIGHT}
                            width={Constants.DEFAULT_IMAGE_WIDTH}
                        />
                    </picture>
                </a>
            </>
        );
    }
}

const Loading = () => {
    return (
        <div className="alpi__image-loader-wrapper">
            <Loader className="alpi__image-loader"/>
        </div>
    );
};

const FallbackImage = memo(function FallbackImage({altText}) {
    const placeHolderImage = {
        fallbackSrc: Constants.PLACEHOLDER_IMAGE_XLARGE_BASE64,
        sources: [
            {
                media: Constants.MEDIA_QUERY_SMALL,
                srcSet: `${Constants.PLACEHOLDER_IMAGE_SMALL_BASE64} 1x, ${Constants.PLACEHOLDER_IMAGE_SMALL_RETINA_BASE64} 2x`,
            },
            {
                media: Constants.MEDIA_QUERY_XLARGE,
                srcSet: `${Constants.PLACEHOLDER_IMAGE_XLARGE_BASE64} 1x, ${Constants.PLACEHOLDER_IMAGE_XLARGE_RETINA_BASE64} 2x`,
            },
        ],
    };

    return (
        <picture className={'alpi__picture-wrapper'}>
            <div className="alpi__fallback-image-content-wrapper">
                <Icon name="placeholder" className="placeholder-icon"/>
            </div>
            {placeHolderImage.sources.map((source) => {
                return <source media={source.media} srcSet={source.srcSet}/>;
            })}
            <img
                className="responsive-image__img-tag"
                src={placeHolderImage.fallbackSrc}
                alt={altText}
                height={Constants.DEFAULT_IMAGE_HEIGHT}
                width={Constants.DEFAULT_IMAGE_WIDTH}
            />
        </picture>
    );
});
